<template>
  <div :class="[classOverride, { 'd-flex': !$vuetify.display.mobile }]">
    <ListActionsButtonsAdd
      class="mr-3 mb-3"
      :add-options="addOptions"
      :permission-name="permissionName"
      :request-name="requestName"
      :translation-name="translationName"
      :default-url="defaultUrl"
      :disabled-tooltip="disabledTooltip"
    />
    <ListActionsButtonsExport
      :query="query"
      :request-name="requestName"
      :translation-name="translationName"
      :exportable="exportable"
    />
  </div>
</template>

<script lang="ts">
export default {
    name : "ActionsButtons",
    props : {
        disabledTooltip : { type : String, required : false, default : "" },
        addOptions : { type : Object, default: () => ({}) },
        query : { type : Object, required : false, default : () => {} },

        exportable : { type : Array, default: () => ([]) },
        requestName : { type : String, required : true },
        translationName : { type : String, required : true },
        permissionName : { type : String, required : true },
        defaultUrl : { type : String, required : true },
        classOverride : { type : String, required : false, default: 'mt-6 mb-3' },
    },
}
</script>
